import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { StateService } from '../services';
import { State } from '../models/state.model';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  private state: State;

  constructor(private stateService: StateService) { 
      this.state = stateService.state;
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
      
    if (this.requests.length > 0)
      this.stateService.showIndeterminateSpinner();
    else
      this.stateService.hideSpinner();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.requests.push(req);

    //console.log("No of requests--->" + this.requests.length);

    if (!req.headers.has('X-Skip-Interceptor'))
    {
      this.stateService.showIndeterminateSpinner();
    }

    return new Observable(observer => {
      const subscription = next.handle(req)
        .subscribe({ 
          next: (event) => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          error: (err) => {
            this.removeRequest(req);
            observer.error(err);
          },
          complete: () => {
            this.removeRequest(req);
            observer.complete();
          }
        });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}